var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.59993 5.40039H16.3999C17.1333 5.40039 17.7333 6.00039 17.7333 6.73372V8.20039C17.7333 8.73372 17.3999 9.40039 17.0666 9.73372L14.1999 12.2671C13.7999 12.6004 13.5333 13.2671 13.5333 13.8004V16.6671C13.5333 17.0671 13.2666 17.6004 12.9333 17.8004L11.9999 18.4004C11.1333 18.9337 9.93327 18.3337 9.93327 17.2671V13.7337C9.93327 13.2671 9.6666 12.6671 9.39994 12.3337L6.8666 9.66706C6.53327 9.33372 6.2666 8.73372 6.2666 8.33372V6.80039C6.2666 6.00039 6.8666 5.40039 7.59993 5.40039Z",
    stroke: "#7A7A7A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2867 5.40039L8 10.6671",
    stroke: "#7A7A7A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.e0a4116d708d7910e0b4b3dddb3446d0.svg";
export { ForwardRef as ReactComponent };